import { render, staticRenderFns } from "./listv2.vue?vue&type=template&id=57843296&scoped=true"
import script from "./listv2.vue?vue&type=script&lang=js"
export * from "./listv2.vue?vue&type=script&lang=js"
import style0 from "./listv2.vue?vue&type=style&index=0&id=57843296&prod&scoped=true&lang=css"
import style1 from "./listv2.vue?vue&type=style&index=1&id=57843296&prod&lang=css"
import style2 from "./listv2.vue?vue&type=style&index=2&id=57843296&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57843296",
  null
  
)

export default component.exports